<template>
    <v-footer app inset class="kp-footer">
        <KpIcon v-if="loading" icon-cls="load ic-spin" color="grey" />
        <v-spacer />
        Minasa - V. {{ version }} | &copy;&nbsp;{{ copyYear }}&nbsp;<a href="https://kadenpartner.ch"
            >kaden und partner ag</a
        >
    </v-footer>
</template>

<script>
import { mapState } from 'vuex';
import { globalVar } from '@/helpers/globals';

export default {
    name: 'KpFooter',
    computed: {
        ...mapState({
            loading: (state) => state.loading,
        }),
        version() {
            return globalVar('version') || '';
        },
        copyYear() {
            let from = 2022;
            let to = new Date().getFullYear();
            if (to > from) {
                return `${from} - ${to}`;
            } else {
                return String(from);
            }
        },
    },
};
</script>
